import styled from 'styled-components';

import { fiveCol } from '../../utils/style';

export default styled.div`
    ${fiveCol()};
`;